import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './responsive.css';
import './design/v2.css';
import App from './App';
import { isV2 } from './design/designFlags';
import reportWebVitals from './reportWebVitals';

// Scope for app-wide redesign tweaks in design/v2.css (removed in classic mode)
if (isV2('shell')) document.documentElement.classList.add('smc-v2');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// index.html paints deep space before React loads; routes that don't show the
// splash screen (which clears it on exit) drop the boot background here.
setTimeout(() => {
  if (!document.querySelector('.spl2')) document.documentElement.classList.remove('spl2-booting');
}, 400);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker — auto-reload when a new version is deployed
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });

  // When the new service worker activates it broadcasts SW_UPDATED.
  // Reload the page so users immediately get the fresh JS bundle.
  navigator.serviceWorker.addEventListener('message', event => {
    if (event.data?.type === 'SW_UPDATED') {
      window.location.reload();
    }
  });
}
